"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconStack = void 0;

var React = __importStar(require("react"));

exports.IconStack = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "45",
    height: "40",
    viewBox: "0 0 45 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    d: "M0.00150299 10.8235C0.0110016 10.3554 0.289997 9.93415 0.7155 9.7446L22.0264 0.100049C22.331 -0.0333497 22.6751 -0.0333497 22.9798 0.100049L44.2907 9.7446C44.6999 9.94585 44.9604 10.3648 44.9604 10.8235C44.9604 11.2822 44.6999 11.701 44.2907 11.9024L36.0755 15.6164L44.23 18.853C44.6811 19.0238 44.9857 19.4545 44.9997 19.9412C45.0113 20.4256 44.7322 20.8726 44.2905 21.0692L36.0752 24.7832L44.2297 28.0175C44.6808 28.1908 44.9854 28.6212 44.9994 29.1057C45.011 29.5925 44.732 30.0395 44.2902 30.236L22.9793 39.8807L22.5026 40L22.0259 39.8807L0.714996 30.236C0.273247 30.0395 -0.00574875 29.5925 0.00575256 29.1057C0.0197525 28.6212 0.324249 28.1908 0.775497 28.0175L8.93 24.8441L0.714752 21.13V21.1277C0.272999 20.9311 -0.00600052 20.4865 0.00549698 19.9997C0.0194969 19.5129 0.324001 19.0847 0.775253 18.9114L8.92975 15.6772L0.7145 11.9632C0.268002 11.7666 -0.0157509 11.3149 0.000747681 10.8235H0.00150299ZM4.287 29.2158L22.5032 37.484L40.7194 29.2158L32.981 26.1593L22.98 30.7135L22.5033 30.8328L22.0267 30.7135L12.0257 26.1593L4.287 29.2158ZM4.287 20.0486L22.5032 28.317L40.7194 20.0511L32.981 16.9946L22.98 21.5488L22.5033 21.6682L22.0267 21.5488L12.0257 16.9946L4.287 20.0486ZM22.5032 19.1523L40.8955 10.8234L22.5032 2.49693L4.11075 10.8234L22.5032 19.1523Z",
    fill: color
  }));
});